import { lazy, Suspense  } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import Addclasses from './contractManagement/classes/Addclasses';
import ViewAddPrices from './contractManagement/classes/Prices/ViewAddPrices/ViewAddPrices';
import Contractlist from './contractManagement/Contractlist/Contractlist';
import NewContractlist from './contractManagement/NewContractlist/NewContractlist';
import Contractmanagement from './contractManagement/contractmanagement';
import Agentlist from './pages/agentprofile/agentlist';
import Createprofile from './pages/agentprofile/createprofile';
import Updateprofile from './pages/agentprofile/updateprofile';
import { ContentRoute, Layout } from './_theme/layout';
import { useSelector } from "react-redux";
import CreateContract from './contractManagement/createContract';
import Createclass from './contractManagement/classes/Createclass';
import Myfile from './pages/myfiles/Myfile';
import BookingConfirmationContainer from './pages/myfiles/BookingConfirmationContainer';
import { SunquestAdminList } from './pages/sunquestAdmin/sunquestAdminList';
import BulkUpdate from './contractManagement/NewContractlist/BulkUpdate';
import NewClass from './contractManagement/NewClass/NewClass';
import NewTariff from './contractManagement/NewTariff/NewTariff';
import NewPrix from './contractManagement/NewPrix/NewPrix';
import AnalyzeContracts from './contractManagement/AnalyzeContracts/AnalyzeContracts';
import PromotionEdit from './pages/promotions/PromotionEdit';
import Promotion from './pages/promotions/Promotion';
import FraudCheck from './pages/fraudCheck/fraudCheck';
import Branding from './pages/branding/branding';
import BulkEmpty from './contractManagement/NewContractlist/BulkEmpty';
import RQBReportGenerator from './pages/reportGenerator/rqbReportGenerator';
import {
  OfflineFlightBookings,
  OfflineFlightCreate,
  OfflineFlightFlights,
  OfflineFlightReleaseManager,
  OfflineFlightSearch,
} from './offlineFlight/routes';
import {
  AccountingFormsOfPayment,
  AccountingInvoice,
  AccountingInvoiceDetail,
  AccountingOffices,
  AccountingReports,
  AccountingCommissionRun,
  AccountingCommissionCheck,
  AccountingBspRun,
  AccountingImportCheck,
  AccountingSuppliers,
  AccountingTransactionTypes,
} from './accounting/routes';

const LoginPage = lazy(() => import('./pages/auth/login'));
const AgentRegisterPage = lazy(() => import('./pages/auth/agentRegister'));
const SetPasswordPage = lazy(() => import('./pages/auth/setPassword'));
const ErrorPage = lazy(() => import('./pages/error'));
const HomePage = lazy(() => import('./pages/home'));

const BusinessPage = lazy(() => import('./pages/business'));
const BusinessCreate = lazy(() => import('./pages/business/create'));
const BusinessUpdate = lazy(() => import('./pages/business/update'));
const ConsortiumPage = lazy(() => import('./pages/consortium'));
const ConsortiumCreate = lazy(() => import('./pages/consortium/create'));
const ConsortiumUpdate = lazy(() => import('./pages/consortium/update'));
const OrganizationPage = lazy(() => import('./pages/organization'));
const OrganizationCreate = lazy(() => import('./pages/organization/create'));
const OrganizationUpdate = lazy(() => import('./pages/organization/update'));

const FeesPage = lazy(() => import('./pages/fees'));
const FeesUpdate = lazy(() => import('./pages/fees/update'));
const FeesView = lazy(() => import('./pages/fees/view'));
const TaxPage = lazy(() => import('./pages/tax'));
const TaxCreate = lazy(() => import('./pages/tax/create'));

const EmailConfigurationPage = lazy(() => import('./pages/business/emailConfiguration'));
const EmailConfigurationUpdate = lazy(() => import('./pages/business/emailConfiguration/update'));
const FraudChecklistPage = lazy(() => import('./pages/fraudCheck/fraudCheck'));
const BrandingPage = lazy(() => import('./pages/branding/branding'))
const CreateBranding = lazy(() => import('./pages/branding/createBranding'))
export function Routes() {
  const isUserLogin = useSelector((state: any) => state.user);
  const isAuthorized: any = isUserLogin.isUserLogedIn;

  return (
    <Switch>
      <Route path="/error" component={ErrorPage} />

      {!isAuthorized && (
        <Route exact path="/register" component={AgentRegisterPage} />
      )}
      {!isAuthorized && (
        <Route exact path="/en/register" component={AgentRegisterPage} />
      )}
      {!isAuthorized && <Route exact path="/" component={LoginPage} />}
      {!isAuthorized && <Route exact path="/auth" component={LoginPage} />}
      {!isAuthorized && <Redirect to="/" />}

      {isAuthorized && (
        <Route path="/">
          <Layout>
            <Suspense fallback={<code>Loading...</code>}>
              <Switch>
                <Redirect exact from="/" to="/offline-flight/search" />
                <ContentRoute exact path="/home" component={HomePage} />

                <ContentRoute exact path="/businesses" component={BusinessPage} />
                <ContentRoute exact path="/businesses/new" component={BusinessCreate} />
                <ContentRoute exact path="/businesses/:travelBusinessesId" component={BusinessUpdate} />
                <ContentRoute exact path="/email-configuration" component={EmailConfigurationPage} />
                <ContentRoute exact path="/email-configuration/:configurationId" component={EmailConfigurationUpdate} />

                <ContentRoute exact path="/consortium" component={ConsortiumPage} />
                <ContentRoute exact path="/consortium/new" component={ConsortiumCreate} />
                <ContentRoute exact path="/consortium/:consortiumId" component={ConsortiumUpdate} />

                <ContentRoute exact path="/organizations" component={OrganizationPage} />
                <ContentRoute exact path="/organizations/new" component={OrganizationCreate} />
                <ContentRoute exact path="/organizations/:orgId" component={OrganizationUpdate} />

                <ContentRoute exact path="/fees" component={FeesPage} />
                <ContentRoute exact path="/fees/:feeId" component={FeesUpdate} />
                <ContentRoute exact path="/fees/view/:feeId" component={FeesView} />

                <ContentRoute exact path="/taxes" component={TaxPage} />
                <ContentRoute exact path="/taxes/:type" component={TaxCreate} />

                <Redirect exact from="/promotions" to="/promotions/loyalty" />
                <ContentRoute exact path="/promotions/loyalty/new" component={PromotionEdit} />
                <ContentRoute exact path="/promotions/loyalty/:id" component={PromotionEdit} />
                <ContentRoute exact path="/promotions/loyalty" component={Promotion} />
                <ContentRoute exact path="/promotions/sales/new" component={PromotionEdit} />
                <ContentRoute exact path="/promotions/sales/:id" component={PromotionEdit} />
                <ContentRoute exact path="/promotions/sales" component={Promotion} />
                <ContentRoute exact path="/promotions/airline/new" component={PromotionEdit} />
                <ContentRoute exact path="/promotions/airline/:id" component={PromotionEdit} />
                <ContentRoute exact path="/promotions/airline" component={Promotion} />

                {/* AGENT PROFILE */}
                <ContentRoute exact path="/agentprofile/:flag" component={Agentlist} />
                <ContentRoute exact path="/create" component={Createprofile} />
                <ContentRoute exact path="/agentprofile/update/:userId" component={Updateprofile} />
                <ContentRoute exact path="/register" component={AgentRegisterPage} />
                <ContentRoute exact path="/en/register" component={AgentRegisterPage} />
                <ContentRoute exact path="/set-password" component={SetPasswordPage} />

                {/* CREATE CONTRACT */}
                <ContentRoute exact path="/Create-contract" component={CreateContract} />
                <ContentRoute exact path="/contractmanagement/Create-class/:tariffId" component={Createclass} />
                <ContentRoute exact path="/contractmanagement/:tariffId" component={Contractmanagement} />
                <ContentRoute exact path="/contractlist" component={Contractlist} />
                <ContentRoute exact path="/newcontractlist" component={NewContractlist} />
                <ContentRoute exact path="/analyze-contracts" component={AnalyzeContracts} />
                <ContentRoute exact path="/bulkUpdate" component={BulkUpdate} />
                <ContentRoute exact path="/newClass" component={NewClass} />
                <ContentRoute exact path="/classes/:SK/:tariffId" component={Addclasses} />
                <ContentRoute exact path="/prices/:tariffId/:classId/:priceId" component={ViewAddPrices} />
                <ContentRoute exact path="/newTariff" component={NewTariff} />
                <ContentRoute exact path="/newPrix" component={NewPrix} />
                <Redirect exact from="/SalesPromotion" to="/promotions/sales" />
                <Redirect exact from="/SalesEdit" to="/promotions/sales/new" />
                <Redirect exact from="/NewSales" to="/promotions/sales/new" />
                <Redirect exact from="/newLoyaltyPromotions" to="/promotions/loyalty/new" />
                <ContentRoute exact path="/newLoyaltyPromotions/:id" component={PromotionEdit} />
                <ContentRoute exact path="/SalesEdit/:id" component={PromotionEdit} />
                <ContentRoute exact path="/FraudCheck" component={FraudChecklistPage} />
                <ContentRoute exact path="/Branding" component={BrandingPage} />
                <ContentRoute exact path="/createBranding/:id" component={CreateBranding} />
                <ContentRoute exact path="/createBranding" component={CreateBranding} />
                <ContentRoute exact path="/bulkEmpty" component={BulkEmpty} />

                {/* MY FILES */}
                <ContentRoute exact path="/myfiles" component={Myfile} />
                <ContentRoute exact path="/booking-confirmation" component={BookingConfirmationContainer} />
                <ContentRoute exact path="/sunquest-cache-admin" component={SunquestAdminList} />

                {/* Report Generator */}
                <ContentRoute exact path="/report-generator/dqb" component={RQBReportGenerator} />

                <ContentRoute exact path="/offline-flight/search" component={OfflineFlightSearch} />
                <ContentRoute exact path="/offline-flight/create" component={OfflineFlightCreate} />
                <ContentRoute exact path="/offline-flight/bookings" component={OfflineFlightBookings} />
                <ContentRoute exact path="/offline-flight/flights" component={OfflineFlightFlights} />
                <ContentRoute exact path="/offline-flight/release-manager" component={OfflineFlightReleaseManager} />

                {/* Leo accounting (invoice) */}
                <ContentRoute exact path="/invoice" component={AccountingInvoice} />
                <ContentRoute exact path="/invoice/offices" component={AccountingOffices} />
                <ContentRoute exact path="/invoice/forms-of-payment" component={AccountingFormsOfPayment} />
                <ContentRoute exact path="/invoice/suppliers" component={AccountingSuppliers} />
                <ContentRoute exact path="/invoice/transaction-types" component={AccountingTransactionTypes} />
                <ContentRoute exact path="/invoice/import-check" component={AccountingImportCheck} />
                <ContentRoute exact path="/invoice/reports" component={AccountingReports} />
                <ContentRoute exact path="/invoice/reports/:reportKey" component={AccountingReports} />
                <ContentRoute exact path="/invoice/reports/commission-runs/:runId" component={AccountingCommissionRun} />
                <ContentRoute exact path="/invoice/reports/bsp-runs/:runId" component={AccountingBspRun} />
                <ContentRoute exact path="/invoice/reports/commission-runs/:runId/:checkNumber" component={AccountingCommissionCheck} />
                {/* Invoice page by invoice number; after the fixed /invoice/* routes above. */}
                <ContentRoute exact path="/invoice/:invoiceId" component={AccountingInvoiceDetail} />

                <Redirect to="/error" />
              </Switch>
            </Suspense>
          </Layout>
        </Route>
      )}
    </Switch>
  );
}
